import 'angular-ui-bootstrap'

let newGame = function() {
  var adjectives = ["adamant", "adroit", "amatory", "animistic", "antic", "arcadian", "baleful", "bellicose", "bilious", "boorish", "calamitous", "caustic", "cerulean", "comely", "concomitant", "contumacious", "corpulent", "crapulous", "defamatory", "didactic", "dilatory", "dowdy", "efficacious", "effulgent", "egregious", "endemic", "equanimous", "execrable", "fastidious", "feckless", "fecund", "friable", "fulsome", "garrulous", "guileless", "gustatory", "heuristic", "histrionic", "hubristic", "incendiary", "insidious", "insolent", "intransigent", "inveterate", "invidious", "irksome", "jejune", "jocular", "judicious", "lachrymose", "limpid", "loquacious", "luminous", "mannered", "mendacious", "meretricious", "minatory", "mordant", "munificent", "nefarious", "noxious", "obtuse", "parsimonious", "pendulous", "pernicious", "pervasive", "petulant", "platitudinous", "precipitate", "propitious", "puckish", "querulous", "quiescent", "rebarbative", "recalcitant", "redolent", "rhadamanthine", "risible", "ruminative", "sagacious", "salubrious", "sartorial", "sclerotic", "serpentine", "spasmodic", "strident", "taciturn", "tenacious", "tremulous", "trenchant", "turbulent", "turgid", "ubiquitous", "uxorious", "verdant", "voluble", "voracious", "wheedling", "withering", "zealous"];
  var nouns = ["ninjas", "chairs", "pancakes", "statues", "unicorns", "rainbows", "lasers", "senors", "bunnies", "captains", "nibblets", "cupcakes", "carrots", "gnomes", "glitters", "potatoes", "salads", "toejams", "curtains", "beets", "toilets", "exorcists", "stick figures", "mermaid eggs", "sea barnacles", "dragons", "jellybeans", "snakes", "dolls", "bushes", "cookies", "apples", "ice cream", "ukuleles", "kazoos", "banjos", "opera singers", "circus", "trampolines", "carousel", "carnival", "locomotives", "hot air balloons", "praying mantis", "animators", "artisans", "artists", "colorists", "inkers", "coppersmiths", "directors", "designers", "flatters", "stylists", "leadmen", "limners", "make-up artists", "models", "musicians", "pencillers", "producers", "programmers", "scenographers", "set decorators", "silversmiths", "teachers", "auto mechanics", "beaders", "bobbin boys", "clerks of the chapel", "filling station attendants", "foremen", "maintenance engineers", "mechanics", "millers", "moldmakers", "panel beaters", "patternmakers", "plant operators", "plumbers", "sawfilers", "shop foremen", "soapers", "stationary engineers", "wheelwrights", "woodworkers"];

  function randomElement(list) {
      var i = Math.floor(Math.random() * list.length);
      return list[i];
  }

	angular.module('lobby')

		.controller('NewGameModalController', [
			'$scope',
			'$uibModalInstance',
      'boardName',
      'weapons',
      'Notification',
			function(
				$scope,
				$uibModalInstance,
        boardName,
        weapons,
        notification
			) {
			var self = this;

      $scope.name = randomElement(adjectives) + ' ' + randomElement(nouns);
      $scope.boardName = boardName;
      $scope.weapons = weapons;
      $scope.public = true;
      $scope.spectators = true;
      $scope.gameType = "race";
      $scope.selectedWeapons = [];

      function updateGameType(boardName) {
        let board = $scope.$parent.$$childHead.boards.find((element) => element.name === boardName);
        if (board)
          $scope.gameType = board.type;
      }

      $scope.isAllWeaponsSelected = () =>
        $scope.selectedWeapons.every(sw => sw);

      $scope.toggleWeapons = () => {
        let newValue = !$scope.isAllWeaponsSelected()
        for (let i = 0; i < $scope.selectedWeapons.length; i++) {
          $scope.selectedWeapons[i] = newValue;
        }
      }

      $scope.toggleWeapon = (index) => {
        $scope.selectedWeapons[index] = !$scope.selectedWeapons[index];
      }

      $scope.abort = function(){
        $uibModalInstance.dismiss();
      };

      $scope.$watch('boardName', (newValue) => {
        updateGameType(newValue);
      });

      $scope.done = function(){
        if($scope.$parent.$$childHead.boards.findIndex((element) => element.name === $scope.boardName) < 0)
          notification.error('No board with name ' + $scope.boardName + ' found');
        else
          $uibModalInstance.close(
            {
              name: $scope.name,
              private: !$scope.public,
              spectators: true,
              board_name: $scope.boardName,
              game_type: $scope.gameType,
              timeout: $scope.timeout,
              weapons: $scope.weapons
                .filter((weapon, index) => $scope.selectedWeapons[index])
                .map(weapon => weapon.weapon_type)
            });
      };
		}]);
};

export default newGame;
